import { LocalOperationResult } from 'hooks/store/types';
import { useSelector, useDispatch } from 'hooks/utils';
import { ConflictedData, selectConflictedData, setConflictedData } from 'store/data/entries';
import { Nullable } from 'types/index';

export function useConflictedData(): LocalOperationResult<
	Nullable<ConflictedData>,
	(data: Nullable<ConflictedData>) => void
> {
	const dispatch = useDispatch();

	function handler(data: Nullable<ConflictedData>) {
		dispatch(setConflictedData(data));
	}

	const data = useSelector(state => selectConflictedData(state.data.entries));

	return [data, handler];
}
